import { isBefore, parseISO } from 'date-fns';
import { IntlKey } from 'locales';
import { ValidationResult } from 'utils/import/validators/validator.model';

export function validateStartDate(inputDate: string, startDate?: string): ValidationResult {
  if (!startDate) {
    return { isValid: true, value: inputDate };
  }

  if (!inputDate || typeof inputDate !== 'string') {
    return { isValid: false, errorMsgs: ['importFileValidator.invalidDateInput' as IntlKey] };
  }

  const input = parseISO(inputDate);
  const start = parseISO(startDate);
  if (isNaN(input.getTime()) || isNaN(start.getTime())) {
    return { isValid: false, errorMsgs: ['importFileValidator.invalidDateInput' as IntlKey] };
  }

  return !isBefore(input, start)
    ? { isValid: true, value: inputDate }
    : { isValid: false, errorMsgs: ['importFileValidator.startDateMustBeBeforeInputDate' as IntlKey] };
}
